import { NewsListItem, PagingItem } from "../entity";
import { DateTimeUtil, LanguageCode } from "webshop-modules";
import { StringUtilities } from "webshop-modules/string/String.utilities";

export class PagingItemProvider {

    public static getTemplateForType(type: PagingItem, data: unknown, basePath: string, lang: string): HTMLElement | undefined {
        switch (type) {
            case PagingItem.NEWS_ITEM:
                return PagingItemProvider.getNewsTemplateWithData(data as NewsListItem, basePath, lang);
            default:
                return;
        }
    }

    private static getNewsTemplateWithData(data: NewsListItem, basePath: string, lang: string): HTMLElement {
        const date = new Date(data.dateFrom);
        const shortDayFormat = DateTimeUtil.getShortDayFormatFor(lang as LanguageCode).format(date).replace('.', '');
        const shortMonthFormat = DateTimeUtil.getShortMonthFormatFor(lang as LanguageCode).format(date);

        const newElementContent = `
                <div class="m-eventListItem__block">
                    <div class="a-badgeDate">
                        <span data-qa='news-day' class="a-badgeDate__day">${ shortDayFormat }</span>
                        <span data-qa='news-mth' class="a-badgeDate__mth">${ shortMonthFormat }</span>
                    </div>
                </div>
    
                <div class="m-eventListItem__block">
                    <h3 class="m-eventListItem__title">${ StringUtilities.stripTags(data.title) }</h3>
                    <p>${ StringUtilities.stripTags(data.summary) }</p>
                </div>
        `;

        const newElement = document.createElement('a');
        newElement.className = 'm-eventListItem isPartial -news js-load-more-item';
        newElement.setAttribute('href', basePath + data.url);
        newElement.setAttribute('data-qa', 'news-item-link');
        newElement.innerHTML = newElementContent;

        return newElement;
    }
}
